module.exports = __webpack_public_path__ + "img/license.af2b4a5e.jpg";